import { InputAdornment, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';
import { handleValidation } from '../../../utils/formUtils';
import './Custom-Text-Field.scss';

const CustomTextField = (props) => {
  const {
    item,
    handleInputChange,
    className,
    type,
    multiline,
    endAdornment,
    startAdroment,
    adromentValue,
    disabled,
    hideAdornmentByDefault,
    characterCount,
    alias,
    maxLength,
    onClickAdromentValue,
    step,
    minRows,
    inputRef = null,
    stripZeroOnSpinner = false,
    disableDot = false,
    allowZero = false,
  } = props;
  const fieldId = item.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();
  const [inputProps, setInputProps] = useState({});
  const [adormentInput, setAdormentValue] = useState({});
  const [validations, setValidations] = useState(item.validations);
  const [hideAdornment, setHideAdornment] = useState(hideAdornmentByDefault);

  useEffect(() => {
    const validationsList = [...item.validations, 'htmlError'];
    setValidations(validationsList);
  }, [item.validations]);

  useEffect(() => {
    let InputPropsObj = {};
    InputPropsObj.maxLength = props.maxLength || 100000;

    if (props.min || props.max) {
      InputPropsObj.min = props.min || 0;
      InputPropsObj.max = props.max || 100000;
    }
    InputPropsObj.step = step ?? 1;
    setInputProps(InputPropsObj);
  }, [props]);

  const adromentValueClick = () => {
    if (onClickAdromentValue) return onClickAdromentValue();
    return false;
  };

  const handlePaste = (e) => {
    if (type === 'number') {
      const pasted = e?.clipboardData?.getData('text');
      if (!/^\d*$/.test(pasted)) {
        e.preventDefault();
      }
    }
  };

  useEffect(() => {
    let InputPropsObj = {};
    if (endAdornment && item?.value !== undefined) {
      InputPropsObj.endAdornment = (
        <InputAdornment position='end'>
          <span
            className={`cusotm-text-field-end-adornment ${onClickAdromentValue ? 'pointer' : ''}`}
            onClick={() => adromentValueClick()}
          >
            {characterCount
              ? `${(item?.value || '')?.toString()?.length}/${props?.maxLength}`
              : adromentValue}
          </span>
        </InputAdornment>
      );
    }
    if (startAdroment) {
      InputPropsObj.startAdornment = (
        <InputAdornment position='start'>
          <span className='cusotm-text-filed-adornment'>{adromentValue}</span>
        </InputAdornment>
      );
    }

    setAdormentValue(InputPropsObj);
  }, [props]);

  const getErrorMessage = () => {
    const errorMsgs = [];
    validations &&
      validations.forEach((validation) => {
        if (item.errors[validation]) {
          errorMsgs.push(item.errors[validation]);
        }
      });
    return errorMsgs.length > 0 ? errorMsgs[0] : null;
  };

  const onChange = (e) => {
    if (type === 'number') {
      let value = e?.target?.value;
      if (value === '' || Number(value) < 0 || (!allowZero && Number(value) === 0)) {
        const currField = { ...item };
        currField.value = null;
        currField.validations = validations;
        handleValidation(currField);
        handleInputChange(currField);
        return;
      }
      if (value > inputProps.max) {
        value = Math.floor(value / 10);
      }
      const currField = { ...item };
      currField.value = Number(value);
      currField.validations = validations;
      handleValidation(currField);
      handleInputChange(currField);
    } else {
      const inputValue = e.target.value;
      const currField = { ...item };
      currField.value = inputValue;
      currField.validations = validations;
      handleValidation(currField);
      handleInputChange(currField);
    }
  };
  const onBlurOption = (input) => {
    if (hideAdornmentByDefault && !item.value) {
      setHideAdornment(true);
    }
  };

  const onFocusOption = (input) => {
    if (hideAdornmentByDefault) {
      setHideAdornment(false);
    }
  };

  return (
    <TextField
      inputRef={inputRef || null}
      id={fieldId + '_input'}
      disabled={disabled}
      label={`${alias ?? ''} ${item?.fieldName}`}
      value={item?.langageValue ?? item?.value}
      multiline={multiline || false}
      required={validations && validations?.includes('required')}
      className={className || 'w-100'}
      onInput={
        stripZeroOnSpinner && type === 'number'
          ? (e) => {
              if (e.target.value === '0') e.target.value = '';
            }
          : undefined
      }
      onChange={(e) => onChange(e)}
      error={getErrorMessage() ? true : false}
      helperText={getErrorMessage()}
      placeholder={item.placeholder}
      type={type || 'text'}
      inputProps={{
        ...inputProps,
        onKeyDown: (e) => {
          if (type === 'number' && ['-', 'e', '+', 'E']?.includes(e?.key)) {
            e?.preventDefault();
          }
          if (type === 'number' && disableDot && e?.key === '.') {
            e?.preventDefault();
          }
        },
        onBeforeInput: (e) => {
          if (type === 'number' && ['-', 'e', '+', 'E']?.includes(e?.data)) {
            e?.preventDefault();
          }
          if (type === 'number' && disableDot && e?.data === '.') {
            e?.preventDefault();
          }
        },
        onPaste: handlePaste,
      }}
      InputProps={!hideAdornment ? adormentInput : null}
      onBlur={(e) => {
        onBlurOption(e);
      }}
      onFocus={(e) => {
        onFocusOption(e);
      }}
      maxLength={maxLength}
      minRows={minRows ? minRows : 0}
    />
  );
};

export default CustomTextField;
